<template>
  <div class="content">
    <div class="control_bar top">
      <div class="search">
        {{ title }}
      </div>
      <div class="controller">
        <ul class="action_buttons">
          <li class="column_add action_button">
            <router-link :to="router" class="add_router">
              {{ addButton }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div style="margin: 20px">{{ info }}</div>

    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_no">
            <div>{{ noLabel }}</div>
          </th>
          <th class="table_contents cell_date">
            <div>{{ startDatetimeLabel }}</div>
          </th>
          <th class="table_contents cell_date">
            <div>{{ endDatetimeLabel }}</div>
          </th>
          <th class="table_contents">
            <div>{{ messageLabel }}</div>
          </th>
          <th class="table_contents cell_button"></th>
          <th class="table_contents cell_button"></th>
        </tr>
        <tr
          class="item_table_row"
          v-for="(maintenance, index) in formatDateList"
          :key="maintenance.maintenanceId"
        >
          <td class="table_no" @click="toDetail(maintenance.maintenanceId)">
            <div>{{ index + 1 }}</div>
          </td>
          <td
            class="table_contents cell_date"
            @click="toDetail(maintenance.maintenanceId)"
          >
            <div>{{ maintenance.startDateTime }}</div>
          </td>
          <td
            class="table_contents cell_date"
            @click="toDetail(maintenance.maintenanceId)"
          >
            <div>{{ maintenance.endDateTime }}</div>
          </td>
          <td
            class="table_contents"
            @click="toDetail(maintenance.maintenanceId)"
          >
            <div class="message_area">{{ maintenance.message }}</div>
          </td>
          <td class="table_content cell_button">
            <input
              type="button"
              :value="editButton"
              class="finish_button"
              @click="toEdit(maintenance.maintenanceId)"
            />
          </td>
          <td class="table_contents cell_button">
            <input
              v-if="
                new Date(maintenance.startDateTime) > new Date() ||
                  new Date(maintenance.endDateTime) <= new Date()
              "
              type="button"
              :value="deleteButton"
              class="common_delete_button"
              @click="openConfirmDeleteModal(maintenance.maintenanceId)"
            />
            <input
              v-if="
                new Date(maintenance.startDateTime) <= new Date() &&
                  new Date(maintenance.endDateTime) > new Date()
              "
              type="button"
              :value="endButton"
              class="common_delete_button"
              @click="openConfirmEndModal(maintenance.maintenanceId)"
            />
          </td>
        </tr>
      </table>
    </div>
    <div class="modal_window" v-if="showConfirmDeleteModal">
      <confirmCustomTitleModalWindow
        :title="confirmDeleteModalTitle"
        :question="confirmDeleteModalQuestion"
        @close="close"
        @ok="deleteMaintenance"
      >
      </confirmCustomTitleModalWindow>
    </div>
    <div class="modal_window" v-if="showConfirmEndModal">
      <confirmCustomTitleModalWindow
        :title="confirmEndModalTitle"
        :question="confirmEndModalQuestion"
        @close="close"
        @ok="endMaintenance"
      >
      </confirmCustomTitleModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showCompleteDeleteModal">
      <completeModalWindow :question="deleteCompleteWord" @close="closeUpdate">
      </completeModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showCompleteEndModal">
      <completeModalWindow :question="endCompleteWord" @close="closeUpdate">
      </completeModalWindow>
    </div>
    <div class="false_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import pagenation from '../../../pagenation.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import confirmCustomTitleModalWindow from '../modalWindow/confirmCustomTitleModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      title: 'メンテナンスリスト',
      info: 'メンテナンス予定の管理を行えます。',
      addButton: '追加',
      editButton: '編集',
      deleteButton: '削除',
      endButton: '終了',
      noLabel: 'No.',
      startDatetimeLabel: '開始日時',
      endDatetimeLabel: '終了日時',
      messageLabel: '表示メッセージ',
      confirmDeleteModalTitle: 'メンテナンス予定削除',
      confirmDeleteModalQuestion: '選択したメンテナンス予定を削除しますか？',
      confirmEndModalTitle: 'メンテナンス終了',
      confirmEndModalQuestion: 'メンテナンスを終了しますか？',
      deleteCompleteWord: '削除しました。',
      endCompleteWord: '終了しました。',
      router: '/master/maintenance/add',
      selectedId: '',
      showConfirmDeleteModal: false,
      showConfirmEndModal: false,
      showCompleteDeleteModal: false,
      showCompleteEndModal: false,
      failureWord: '',
      showFailureModal: false,
      showloadingModal: false,
      maintenanceList: []
    }
  },
  components: {
    pagenation,
    completeModalWindow,
    confirmCustomTitleModalWindow,
    loadingModalWindow
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    tableHeight() {
      const otherHeight = 146
      return this.windowHeight - otherHeight + 'px'
    },
    formatDateList() {
      var items = []
      for (let maintenance of this.maintenanceList) {
        var item = Object()
        item.maintenanceId = maintenance.maintenanceId
        item.message = maintenance.message
        var s = new Date(maintenance.startDateTime)
        item.startDateTime =
          s.getFullYear() +
          '/' +
          this.padZero(s.getMonth() + 1) +
          '/' +
          this.padZero(s.getDate()) +
          '  ' +
          this.padZero(s.getHours()) +
          ':' +
          this.padZero(s.getMinutes()) +
          ':' +
          this.padZero(s.getSeconds())
        var e = new Date(maintenance.endDateTime)
        item.endDateTime =
          e.getFullYear() +
          '/' +
          this.padZero(e.getMonth() + 1) +
          '/' +
          this.padZero(e.getDate()) +
          '  ' +
          this.padZero(e.getHours()) +
          ':' +
          this.padZero(e.getMinutes()) +
          ':' +
          this.padZero(e.getSeconds())
        items.push(item)
      }
      return items
    }
  },
  async created() {
    this.showloadingModal = true
    this.$store.dispatch('systemAdminDefine/clearCompanyInfo')
    this.$store.dispatch('maintenance/clearAddData')
    this.$store.dispatch('maintenance/clearUpdateData')
    this.$store.dispatch('maintenance/clearSelectedTenantList')
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    try {
      await this.$store.dispatch('maintenance/setMaintenance')
      this.maintenanceList = this.$store.state.maintenance.maintenanceList
    } catch (error) {
      let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_650001
      this.createErrorMessage(error, eventNumber, 'MSGCRD0107')
      this.showFailureModal = true
    }
    this.$store.state.maintenance.selectAllFlag = false
    this.showloadingModal = false
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    toEdit(maintenanceId) {
      this.$store.dispatch('maintenance/inputUpdate', {
        name: 'maintenanceId',
        value: maintenanceId
      })
      this.$router.push('/master/maintenance/edit')
    },
    close() {
      this.showConfirmDeleteModal = false
      this.showConfirmEndModal = false
      this.showCompleteDeleteModal = false
      this.showCompleteEndModal = false
      this.showFailureModal = false
    },
    async closeUpdate() {
      this.close()
      this.showloadingModal = true
      this.$store.dispatch('systemAdminDefine/clearCompanyInfo')
      this.$store.dispatch('maintenance/clearAddData')
      this.$store.dispatch('maintenance/clearUpdateData')
      this.$store.dispatch('maintenance/clearSelectedTenantList')
      this.updateWindowHeight()
      try {
        await this.$store.dispatch('maintenance/setMaintenance')
        this.maintenanceList = this.$store.state.maintenance.maintenanceList
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0107')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    openConfirmDeleteModal(maintenanceId) {
      this.selectedId = maintenanceId
      this.showConfirmDeleteModal = true
    },
    openConfirmEndModal(maintenanceId) {
      this.selectedId = maintenanceId
      this.showConfirmEndModal = true
    },
    async deleteMaintenance() {
      this.showConfirmDeleteModal = false
      this.showloadingModal = true
      try {
        await this.$store.dispatch('maintenance/deleteMaintenance', {
          maintenanceId: this.selectedId
        })
        this.showCompleteDeleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650004
        this.createErrorMessage(error, eventNumber, 'MSGCRD0094')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async endMaintenance() {
      this.showConfirmEndModal = false
      this.showloadingModal = true
      try {
        await this.$store.dispatch('maintenance/deleteMaintenance', {
          maintenanceId: this.selectedId
        })
        this.showCompleteEndModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650004
        this.createErrorMessage(error, eventNumber, 'MSGCRD0094')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async toDetail(maintenanceId) {
      this.showloadingModal = true
      this.$store.dispatch('maintenance/inputUpdate', {
        name: 'maintenanceId',
        value: maintenanceId
      })
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        this.$router.push('/master/maintenance/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650005
        this.createErrorMessage(error, eventNumber, 'MSGCRD0112')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    }
  }
}
</script>
<style scoped>
.control_bar {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
}
.table_scroll {
  width: 100%;
}
.cell_date {
  width: 150px;
  min-width: 150px;
}
.cell_button {
  width: 90px;
}
.table_contents {
  padding: 5px;
}
.message_area {
  max-width: 500px;
  word-wrap: break-word;
  white-space: pre-wrap;
}
th {
  position: sticky;
  top: 0;
  background-color: #ddffff;
}
.content_title {
  border-spacing: 0;
  width: 100%;
  background-color: #ddffff;
}
.center {
  overflow: auto;
  height: calc(100vh - 116px);
}
.common_delete_button,
.finish_button {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/maintenance/maintenanceList.vue